// extracted by mini-css-extract-plugin
module.exports =  {"editGallery":"GalleryEditButton-GalleryEditButton-editGallery-e8fb6fc1","fullWidth":"GalleryEditButton-GalleryEditButton-fullWidth-ba306a8c"};